module.exports = __webpack_public_path__ + "media/img/frontend_application/footericon/facebook-3fc99d29176e146fb735107915457f9f.svg";